// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-summary{line-height:1.8}.lad-summary span{line-height:1.8;display:inline;display:initial}.lad-summary--actions{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.lad-summary .inline-toogle{display:inline-block}.lad-summary .inline-toogle i{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
